import { createContext } from 'react';

/** An optional field whose writes have all settled. */
export interface SettledOptionalField {
  subitemId: string;
  field: string;
  /** Whether the server now holds text for the field. */
  hasText: boolean;
}

/**
 * Hears when an optional field's writes have all settled, for a parent whose
 * layout depends on what the server holds (the phone's caller line).
 */
export const OptionalFieldSettledContext = createContext<
  ((settled: SettledOptionalField) => void) | undefined
>(undefined);
